export const capitalize = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};


export const weightDescription = (weight) => {
  const numericWeight = parseInt(weight, 10);
  
  if (numericWeight === 400) {
    return 'Normal';
  } else if (numericWeight === 500) {
    return 'Medio';
  } else if (numericWeight >= 700) {
    return 'Negrita';
  }
  
  return weight;
};

export const translateAlign = (align) => {
  switch (align) {
    case 'left':
      return 'Izquierda';
    case 'center':
      return 'Centro';
    case 'right':
      return 'Derecha';
    default:
      return align;
  }
};